import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoadingState } from '../components/LoadingState';

interface Props {
  /** Optional permission required to access the route. */
  permission?: string;
}

/** Guards routes: redirects unauthenticated users to /login and enforces permission. */
export function ProtectedRoute({ permission }: Props) {
  const { user, loading, hasPermission } = useAuth();

  if (loading) {
    return <LoadingState fullScreen label="Loading your workspace…" />;
  }

  if (!user) return <Navigate to="/login" replace />;
  if (permission && !hasPermission(permission)) return <Navigate to="/forbidden" replace />;

  return <Outlet />;
}
